import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { stat } from 'fs'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  plugins: [
    createPersistedState()
  ],
  state: {
    tokenappolo: '',
    usuario: [],
    empresa: [],
    idempresa: '',
    logo64: '',
    config: {},
    api: '',
    ipMaquina: ''
  },
  mutations: {
    usuarioPer (state, data) {
      state.usuario.Empresa[0].permisos = data.Empresa[0].permisos
    },
    login (state, data) {
      state.usuario = data.usuario
      state.empresa = data.usuario.Empresa
      state.tokenappolo = data.token
    },
    empresaSelec (state, data) {
      state.empresa = data
    },
    empresa (state, data) {
      state.idempresa = data
    },
    logo64 (state, data) {
      state.logo64 = data
    },
    logout (state) {
      state.tokenappolo = ''
      state.usuario = []
      state.empresa = []
      state.idempresa = ''
      state.config = {}
    },
    usuario (state, data) {
      state.usuario = data
    },
    config (state, data) {
      state.config = {...data}
    },
    configTasa (state, data) {
      state.config.tasa.tasaDia.valor = data
    },
    api (state, data) {
      state.api = data
    },
    ipMaquina (state, data) {
      state.ipMaquina = data
    }
  },
  actions: {
    usuarioPer ({ commit }, data) {
      commit('usuarioPer', data)
    },
    login ({ commit }, data) {
      commit('login', data)
    },
    empresaSelec ({ commit }, data) {
      commit('empresaSelec', data)
    },
    empresa ({ commit }, data) {
      commit('empresa', data)
    },
    config ({ commit }, data) {
      commit('config', data)
    },
    configTasa ({ commit }, data) {
      commit('configTasa', data)
    },
    logo64 ({ commit }, data) {
      commit('logo64', data)
    },
    logout ({ commit }) {
      commit('logout')
    },
    setuser ({ commit }, data) {
      commit('usuario', data)
    },
    api ({ commit }, data) {
      commit('api', data)
    },
    ipMaquina ({ commit }, data) {
      commit('ipMaquina', data)
    }
  }
})
